
/**
 * Loads an image into an HTMLImageElement and returns a promise that resolves when the image is loaded.
 * @param imageUrl The URL of the image to load.
 * @param imageElem The HTMLImageElement to load the image into.
 * @returns A promise that resolves to the HTMLImageElement when the image is loaded.
 * If the image URL is null or undefined, the promise resolves immediately with the image element.
 */
export function loadImageIntoElement(imageUrl: string | undefined | null, imageElem: HTMLImageElement) : Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        if(imageElem !== null && imageUrl !== undefined && imageUrl !== null) {
            imageElem.onload = () => {
                resolve(imageElem);
            }
            imageElem.src = imageUrl;
        } else {
            resolve(imageElem);
        }
    });
}